import { useState } from "react";
import { LogOut } from "lucide-react";
import { LoginForm } from "@/components/admin/LoginForm";
import { DashboardHome } from "@/components/admin/DashboardHome";
import { ReviewsTab } from "@/components/admin/ReviewsTab";
import { BidsTab } from "@/components/admin/BidsTab";
import { ProjectsTab } from "@/components/admin/ProjectsTab";
import { CompaniesTab } from "@/components/admin/CompaniesTab";
import { AreasTab } from "@/components/admin/AreasTab";
import { BusinessTab } from "@/components/admin/BusinessTab";
import { AiTab } from "@/components/admin/AiTab";
import { SettingsTab } from "@/components/admin/SettingsTab";
import { adminBtnCls, adminTabCls } from "@/components/admin/shared";

const TABS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "reviews", label: "Reviews" },
  { key: "bids", label: "Bid Requests" },
  { key: "projects", label: "Projects" },
  { key: "companies", label: "Companies" },
  { key: "areas", label: "Service Areas" },
  { key: "business", label: "Business Info" },
  { key: "ai", label: "AI Assistant" },
  { key: "settings", label: "Settings" },
];

export default function AdminPage() {
  const [token, setToken] = useState(() => localStorage.getItem("r3-admin-token") || "");
  const [tab, setTab] = useState("dashboard");

  const onAuthError = () => {
    localStorage.removeItem("r3-admin-token");
    setToken("");
  };

  if (!token) {
    return <LoginForm onLogin={setToken} />;
  }

  return (
    <main data-testid="admin-page" className="min-h-screen bg-ink pb-24 pt-24 md:pt-28">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="font-display text-3xl font-black uppercase tracking-tight text-white md:text-4xl">
              R3Stan <span className="text-gold">Admin</span>
            </p>
            <p className="mt-1 text-xs uppercase tracking-[0.2em] text-neutral-500">
              Private dashboard — manage content and submissions
            </p>
          </div>
          <button
            data-testid="admin-logout-btn"
            onClick={() => {
              localStorage.removeItem("r3-admin-token");
              setToken("");
            }}
            className={adminBtnCls}
          >
            <LogOut className="h-3.5 w-3.5" />
            Log out
          </button>
        </div>

        <div
          data-testid="admin-main-tabs"
          className="mt-8 flex gap-2.5 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`admin-maintab-${t.key}`}
              onClick={() => setTab(t.key)}
              className={adminTabCls(tab === t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8">
          {tab === "dashboard" && (
            <DashboardHome
              onNavigate={setTab}
              email={localStorage.getItem("r3-admin-email") || "admin"}
            />
          )}
          {tab === "reviews" && <ReviewsTab onAuthError={onAuthError} />}
          {tab === "bids" && <BidsTab onAuthError={onAuthError} />}
          {tab === "projects" && <ProjectsTab onAuthError={onAuthError} />}
          {tab === "companies" && <CompaniesTab onAuthError={onAuthError} />}
          {tab === "areas" && <AreasTab onAuthError={onAuthError} />}
          {tab === "business" && <BusinessTab onAuthError={onAuthError} />}
          {tab === "ai" && <AiTab onAuthError={onAuthError} />}
          {tab === "settings" && <SettingsTab onAuthError={onAuthError} />}
        </div>
      </div>
    </main>
  );
}
